import { createFileRoute } from '@tanstack/react-router';
import { CannedRepliesPage } from '../../features/settings/components/canned-replies-page.js';

export const Route = createFileRoute('/admin/canned-replies')({ component: CannedRepliesPage });
